import React, { useEffect, useState } from "react";
import {
  Backdrop,
  Box,
  CircularProgress,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";

import PropTypes from "prop-types";
import { ServiceApi } from "../services/index.service";
import DriveThruPreSellBoardConfiguration from "./DriveThruPreSellBoardConfiguration";
import DMBPreSellBoardConfiguration from "./DMBPreSellBoardConfiguration";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import { Combobox } from "@headlessui/react";
import { Transition } from "react-transition-group";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setStorePermissions, storeSet } from "../redux/store/storeSlice";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}
TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const PreSellBoardConfiguration = () => {
  const serviceapi = new ServiceApi();
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const [store, setStore] = useState(null);
  const data = useSelector((state) => state);
  const { storage } = useSelector((state) => state);
  const [permissions, setPermissions] = useState(null);
  const [permissionLoading, setPermissionLoading] = useState(false);
  const havePermissionToView = (menu) => {
    return permissions?.[menu] === true
  };
  const tabsList = [
    {
      id: 1,
      title: "Drive-Thru",
      label: "Drive-Thru",
      disabled: false,
      show: havePermissionToView("DigitalDriveThruWithPreSellBoard"),
    },
    {
      id: 2,
      label: "Digital Display",
      title: "Digital Display",
      disabled: false,
      show: false,
    },
  ];

  React.useEffect(() => {
    if(store?.intStoreID){
      fetchStorePermissions();
    }
  }, [store]);
  

  useEffect(() => {
    setStore(storage?.store);
  }, [storage?.store]);

  const fetchStorePermissions = async () => {
    const req = {
      intStoreID: store?.intStoreID,
      role: data?.profile?.role,
    };
    setPermissionLoading(true)
    const res = await serviceapi.fetchStorePermissions(req);
    setPermissionLoading(false)
    setPermissions(res);
    dispatch(setStorePermissions(res))
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={permissionLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <div className="py-6 mt-16">
        <header>
          <div className="flex justify-between items-center mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
            <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
              Pre-Sell Board Configuration
            </h1>
          </div>
        </header>
        {store?.intStoreID ?
       ( <main>
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8 py-8">
            <div className="rounded-md bg-white shadow-md">
              <Box sx={{ width: "100%" }} className="px-4">
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <Tabs value={value} onChange={handleChange}>
                    {tabsList?.filter(i=>i?.show)?.map((itm, index) => (
                      <Tab
                        label={itm.label}
                        {...a11yProps(itm.id)}
                        key={itm.id}
                        disabled={itm.disabled}
                      />
                    ))}
                  </Tabs>
                </Box>
                {tabsList?.filter(i=>i?.show)?.map((tabItem, index) => {
                  return (
                    <TabPanel key={tabItem.id} value={value} index={index}>
                      {tabItem.id === 1 && (
                        <DriveThruPreSellBoardConfiguration
                          intStoreID={store?.intStoreID}
                        />
                      )}
                      {tabItem.id === 2 && (
                        <DMBPreSellBoardConfiguration
                          intStoreID={store?.intStoreID}
                        />
                      )}
                    </TabPanel>
                  );
                })}
              </Box>
            </div>
          </div>
        </main>):null}
      </div>
    </>
  );
};

export default PreSellBoardConfiguration;
